import React from 'react';
import WidgetAnnotationModal from './WidgetAnnotationModal';

const DashboardModal = (props) => {
  return (<WidgetAnnotationModal
    modelType="dashboard"
    baseUrlLabel="Overview"
    {...props}
  />);
};

export default DashboardModal;
